<template>
  <v-container>
    <!-- <v-layout justify-space-between>
      <h1>New Fixed Cost Trip</h1>
    </v-layout>-->
    <v-layout justify-center py-3 row wrap>
      <v-flex xs12 md10 xl8>
        <SimpleCard>
          <v-flex pl-5 pb-3>
            <v-layout justify-start align-content-start row wrap>
              <v-flex xs12>
                <h4>Booking Settings</h4>
              </v-flex>
              <v-flex xs12>
                <v-row align-center>
                  <v-flex shrink pr-2>
                    <v-checkbox
                      v-model="chargeCancellationFee"
                      label="Charge Cancellation Fee"
                    ></v-checkbox>
                  </v-flex>
                </v-row>
              </v-flex>
              <v-flex xs12>
                <v-row align-center>
                  <v-flex shrink pr-2>
                    <v-checkbox
                      v-model="chargeExtrasInCancellationFee"
                      label="Charge Extras in Cancellation Fee"
                    ></v-checkbox>
                  </v-flex>
                </v-row>
              </v-flex>
              <v-flex xs12>
                <v-row align-center>
                  <v-flex shrink pr-2>
                    <v-currency-field
                      type="number"
                      v-model="cancellationFee"
                      label="Cancellation Fee"
                      v-bind="currency_config"
                      :min="0"
                    ></v-currency-field>
                  </v-flex>
                </v-row>
              </v-flex>
              <v-flex xs12>
                <v-row align-center>
                  <v-flex shrink pr-2>
                    <v-text-field
                      type="number"
                      v-model="asapLatenessFeeWaiveMinutes"
                      label="ASAP Lateness Fee Waive (Minutes)"
                      :min="0"
                    ></v-text-field>
                  </v-flex>
                </v-row>
              </v-flex>
              <v-flex xs12>
                <v-row align-center>
                  <v-flex shrink pr-2>
                    <v-text-field
                      type="number"
                      v-model="prebookedLatenessFeeWaiveMinutes"
                      label="Prebooked Lateness Fee Waive (Minutes)"
                      :min="0"
                    ></v-text-field>
                  </v-flex>
                </v-row>
              </v-flex>
            </v-layout>
            <v-btn @click="update">Update</v-btn>
          </v-flex>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";

import SimpleCard from "@/components/widget/SimpleCard.vue";

import axios from "axios";
axios.defaults.withCredentials = true;

import SimpleCurrencyInput from "@/components/widget/input/SimpleCurrencyInput.vue";

import qs from "qs";

export default {
  name: "fixed_pricing",
  components: {
    Overview,
    SimpleCard,
    SimpleCurrencyInput,
  },
  data: function () {
    return {
      currency_config: {
        decimal: ".",
        prefix: "£",
        precision: 2,
        masked: false,
        allowBlank: true,
      },
      loading: false,
      chargeCancellationFee: false,
      cancellationFee: 0,
      chargeExtrasInCancellationFee: false,
      asapLatenessFeeWaiveMinutes: 0,
      prebookedLatenessFeeWaiveMinutes: 0
    };
  },
  mounted: async function () {
    this.getBookingSettings();

    console.log("HELLO")
  },
  methods: {
    getBookingSettings: function (p) {
      this.loading = true;

      var url = `${this.$store.state.apiUrl}/booking/cancellation/settings/get`;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error == "no_error") {
            
            vm.chargeCancellationFee = res.data.booking_cancellation_policy.charge_cancellation_fee ;
            vm.cancellationFee = res.data.booking_cancellation_policy.cancellation_fee / 100;
            vm.chargeExtrasInCancellationFee = res.data.booking_cancellation_policy.charge_extras_in_cancellation_fee;
            vm.asapLatenessFeeWaiveMinutes = res.data.booking_cancellation_policy.asap_lateness_fee_waive_minutes;
            vm.prebookedLatenessFeeWaiveMinutes = res.data.booking_cancellation_policy.prebooked_lateness_fee_waive_minutes;

          } else {
            alert("Failed to get settings");
          }
        })
        .catch(function (err) {
          alert("Internal Server Error");
          console.error(err);
        });
    },
    update: function (p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${
        this.$store.state.apiUrl
      }/booking/cancellation/settings/update`;

      var completed = this.success;

      console.log(url);

      var vm = this;

      axios({
        url: url,
        method: "POST",
        data: JSON.stringify({
          charge_cancellation_fee: vm.chargeCancellationFee, 
          cancellation_fee:(vm.cancellationFee  * 100).toFixed(0), 
          charge_extras_in_cancellation_fee:vm.chargeExtrasInCancellationFee, 
          asap_lateness_fee_waive_minutes:vm.asapLatenessFeeWaiveMinutes, 
          prebooked_lateness_fee_waive_minutes:vm.prebookedLatenessFeeWaiveMinutes, 
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then(function (res) {
          if (res.data.error == "no_error") {
            alert("Settings Updated");
          } else {
            alert("Settings failed to update: " + res.data.error.message);
          }
        })
        .catch(function (err) {
          alert("Internal Server Error");
        });
    },
  },
};
</script>
